import { Component, HostListener, inject, input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';
// import { PaymentsItemService } from '../../features/payments/services/payments.service';
import { PaginationHelper } from '../../shared/services/pagination.service';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DialogRef } from '@angular/cdk/dialog';
import { PAYMENT_MODES } from '../../helpers/helper-file';
import { FormsModule } from '@angular/forms';
import { PaymentsService } from '../../features/payments/services/payments.service';
import { PaymentMethodsEnum } from '../../../assets/enum/paymentMethodsEnum';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';


@Component({
  selector: 'app-payment-received',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    AgGridAngular,
    FormsModule,
    // PermissionDirective
  ],
  templateUrl: './payment-received.component.html',
  styleUrl: './payment-received.component.scss',
})
export class PaymentReceivedComponent {
  public viewPortSize: boolean = false;
  public loading: boolean = true;
  public rowData: any[] = [];
  public paginationPageSizeSelector: number[] | boolean = [10];
  private searchSubject = new Subject<string>();
  page = 0;
  pageSize = 10;
  totalPage = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];
  search: any;
  startDate: any;
  endDate: any;
  paymentModeList: any;
  selectedModes: string[] = [];
  selectedCount: number = 0;
  columnDefs: ({ headerName: string; field: string; flex: number; cellRenderer?: undefined; floatingFilter?: undefined; filter?: undefined; } | { headerName: string; field: string; flex: number; cellRenderer: (params: any) => string; floatingFilter?: undefined; filter?: undefined; } | { field: string; headerName: string; flex: number; cellRenderer: (params: any) => HTMLDivElement; floatingFilter: boolean; filter: boolean; })[];
  // Permission = Permission;
  canCreatePaymentReceived$ = this.permissionService.hasPermission(
    ModuleIds.PaymentReceived,
    'Create'
  );
  canEditPaymentReceived$ = this.permissionService.hasPermission(
    ModuleIds.PaymentReceived,
    'Edit'
  );
  canEditPaymentReceived:boolean = false;

  constructor(
    private router: Router,
    private itemService: PaymentsService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.fetchItems();
    this.loadPaymentMethods();
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search=searchTerm;
        this.fetchItems();
      });

    this.checkViewportSize();
    this.canEditPaymentReceived$.subscribe(val => {
      this.canEditPaymentReceived = val;
    });
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  // openDialog() {
  //   const dialogRef = this.dialog.open(UploadPaymentReceivedDialog);
  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result === 'refresh') {
  //       this.fetchItems();
  //     }
  //   });
  // }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {

    this.columnDefs = [
      {
        headerName: 'Date',
        field: 'data',
        flex: this.viewPortSize ? 1 : 0,
      },
      { headerName: 'Payment Code', field: 'paymentNo', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Reference No', field: 'referenceNo', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Customer Name', field: 'name', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Invoice', field: 'invoice', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Mode', field: 'mode', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Payment Status', field: 'paymentStatus', flex: this.viewPortSize ? 1 : 0 ,
        cellRenderer: (params: any) => {
          const paymentStatus = params.data?.paymentStatus;
          return paymentStatus === 'Pending' ? `<span style="color: orange;">${paymentStatus}</span>` :paymentStatus === 'Cancelled' ? `<span style="color: red;">${paymentStatus}</span>` : `<span style="color: green;">${paymentStatus}</span>`;
      }
      },
      { headerName: 'Amount', field: 'amount', flex: this.viewPortSize ? 1 : 0 },
      {
        field: 'action',
        headerName: 'Actions',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.gap = '20px';
  
          const editIcon = document.createElement('img');
          editIcon.src = 'assets/images/icons/icon-edit.svg';
          editIcon.style.cursor = 'pointer';
          editIcon.setAttribute('data-action', 'edit');
  
          // const deleteIcon = document.createElement('img');
          // deleteIcon.src = 'assets/images/icons/icon-delete.svg';
          // deleteIcon.style.cursor = 'pointer';
          // deleteIcon.setAttribute('data-action', 'delete');
          if(params.data?.paymentStatus==='Pending' && this.canEditPaymentReceived){
            container.appendChild(editIcon);
          }
          // if(this.profileName === 'admin'){
          // container.appendChild(deleteIcon);
          // }
  
          // this.store.select(selectPermissions.hasPermission('31', Permission.Edit)).subscribe((canEdit) => {
          // });
        // this.store.select(selectPermissions.hasPermission('31', Permission.Delete)).subscribe((canDelete) => {
        //     if (canDelete) {
              // container.appendChild(deleteIcon);            
            // }
          // });
          return container;
        },
        floatingFilter: false,
        filter: false,
      },
    ];
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  // public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';

  fetchItems( pageSize: number = 10) {
    this.loading = true;
    if (pageSize) {
      this.pageSize = pageSize;
    }
    const filter={
      paymentType:'Invoice',
      paymentMethod:this.selectedModes
    }    
    const skip = this.page * this.pageSize;
    const input = {
      search: this.search,
      limit: this.pageSize,
      filter:filter,
      // advancedSearch: this.advancedSearch,
      // startDate:this.startDate,
      // endDate: this.endDate,
      skip,
    }
    this.itemService.findAllPaymentsWithPagination(input).subscribe({
      next: (payments) => {
        this.totalPage = Math.ceil(
          (payments?.total || payments?.payments?.length) / this.pageSize
        );   
        this.rowData =  (payments?.payments || []).map((item: any) => {
          return {
            id: item?.id,
            data:
              this.datePipe.transform(item?.paymentDate, 'dd/MM/YYYY') || '--',
            paymentNo: item?.paymentCode || '--',
            referenceNo: item?.referenceNo || '--',
            name: item?.customerData?.firstName + ' ' + item?.customerData?.lastName || '--',
            invoice: item?.paymentInfo?.[0]?.invoice?.invoiceNo || '--',
            mode: item?.paymentMethod || '--',
            paymentStatus: item?.paymentStatus || '--',
            amount: item?.amount.toFixed(2) || '--',
          };
        });
        // Update pagination options based on the rowData length
        this.paginationPageSizeSelector =
          PaginationHelper.getPaginationPageSizeOptions(this.rowData);
        this.loading = false;
      },
    });
  }

  nextPage() {
    if (this.page + 1 < this.totalPage) {
      this.page++;
      this.fetchItems(this.pageSize);
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.fetchItems(this.pageSize);
    }
  }

  onPageSizeChange(event: Event): void {
    const newSize = Number((event.target as HTMLSelectElement).value);
    console.log('New Page Size:', newSize);
    this.pageSize = newSize; // ✅ Correctly update pageSize
    this.page = 0; // ✅ Reset to first page
    this.fetchItems(this.pageSize); // ✅ Use new pageSize
  }

  toggleMode(mode: string) {
    if (this.selectedModes.includes(mode)) {
      this.selectedModes = this.selectedModes.filter((m) => m !== mode);
    } else {
      this.selectedModes.push(mode);
    }
    this.selectedCount = this.selectedModes?.length;
  }

  onApplyFilters() {
    this.fetchItems();
    this.toggleDropdown();
  }

  clearFilters() {
    this.selectedModes = [];
    this.fetchItems();
    this.toggleDropdown();
    this.selectedCount = 0;
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  private loadPaymentMethods() {
        this.paymentModeList = Object.values(PaymentMethodsEnum).map((type) => ({
          label: type.label,
          value: type.value,
        }));
      }
  

  onCellClicked(params: any) {
    // this.router.navigate([`payments-made/payments-made-details`]);
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        this.openEdit(params?.data);
      } 
      // else if (action === 'delete') {
      //   this.onDeleteJournal(params?.data);
      // }
    } else {
    const id = params.data?.id;
    this.router.navigate([`payment-received/payment-received-details`], {
      queryParams: { id: id },
    });
  }
  }

  openEdit(journalData: any) {
    const journalId = journalData?.id;
    if (journalId) {
      this.router.navigate([`/payment-received/update-payment/${journalId}`]);
    }
  }
}

// @Component({
//   selector: 'upload-payment-received-dialog',
//   templateUrl: 'upload-payment-received-dialog.html',
//   styleUrls: ['./payment-received.component.scss'],
//   standalone: true,
//   imports: [CommonModule, MatDialogModule, MatButtonModule],
// })
// export class UploadPaymentReceivedDialog {
//   file: any = null;
//   url: any = null;

//   constructor(
//     private toastr: ToastrService,
//     private itemService: PaymentsItemService,
//     private dialogRef: MatDialogRef<UploadPaymentReceivedDialog>
//   ) { }

//   ngOnInit() {
//     document.addEventListener('dragover', this.preventDefaultBehavior);
//     document.addEventListener('drop', this.preventDefaultBehavior);
//   }

//   preventDefaultBehavior(event: DragEvent) {
//     event.preventDefault();
//   }

//   onDragOver(event: DragEvent) {
//     event.preventDefault();
//   }

//   onDrop(event: DragEvent) {
//     event.preventDefault();

//     if (event.dataTransfer?.files.length) {
//       this.onFileSelected({ target: { files: event.dataTransfer.files } });
//     }
//   }

//   onFileSelected(event: any): void {
//     const input = event.target as HTMLInputElement;
//     if (input.files && input.files.length > 0) {
//       const file = input.files[0];
//       this.file = file;
//     }
//   }

//   uploadDocuments(csvFile: any) {
//     this.itemService.bulkCreatePayment(csvFile).subscribe({
//       next: (response) => {
//         if (response == true) {
//           this.toastr.success('Bulk updated successfully!');
//           this.dialogRef.close('refresh');
//         }
//       },
//       error: (error) => {
//         this.toastr.error(error.message, 'Bulk updated failed');
//         this.dialogRef.close();
//       },
//     });
//   }

//   removeFile(): void {
//     this.file = null;
//     const input = document.querySelector(
//       'input[type="file"]'
//     ) as HTMLInputElement;
//     if (input) {
//       input.value = '';
//     }
//   }

//   onUpload() {
//     this.uploadDocuments(this.file);
//   }

//   ngOnDestroy() {
//     document.removeEventListener('dragover', this.preventDefaultBehavior);
//     document.removeEventListener('drop', this.preventDefaultBehavior);
//   }
// }
